import React from 'react'
import aboutContactImage from '../../img/background-contact.webp'; // Replace with the correct image path
import './Contact.css'
import ContactForm from './ContactForm';
import Map from './Map';
import Footer from '../home-page/Footer';

export default function Contact() {
  return (
    <>
    <div>
      <div className="contact-hero-section">
      <img src={aboutContactImage} alt="About Us" className="contact-hero-image" />
      <div className="about-hero-overlay"></div>
      <div className="about-hero-content">
        <h1>Contact Us</h1>
        <div className="breadcrumb">
          {/* <span>Pages</span> &gt; <span>About Us</span> */}
        </div>
      </div>
    </div>
    </div>
    <ContactForm/>
    <Map/>
    <Footer/>
    </>
  )
}
